import React from 'react'

const ShowNavLinksModal = () => {
  return (
    <div  className="md:hidden fixed inset-0 z-[1000] !mt-0 grid place-items-center overflow-auto bg-white bg-opacity-10 backdrop-blur-sm">
     
</div>
  )
}

export default ShowNavLinksModal